export const member = {
    labels: {
    },
    modals: {
        titles: {
            member_add: "Adicionar membro",
            member_remove: "Remover Membro",
        },
        messages: {
            member_remove: "Você deseja mesmo remover o membro <strong>{name}</strong>?<br/>Esta ação não pode ser desfeita.",
        }
    },
    texts: {
    },
};
